import { ReactNode } from 'react';
import { Stack } from '@mui/material';

import { ITableLabelDisplayedRows, ITableState } from '/shared/Table/interfaces/ITableDataState';

import { GenericTablePagination } from '../TablePagination';

export const AttachmentPagination = <T extends object>() => {
  function customLabelDisplayedRows({ from, to }: ITableLabelDisplayedRows): ReactNode {
    return (
      <Stack alignItems='center' direction='row' component='span'>
        {from}-{to}
      </Stack>
    );
  }
  return (state: ITableState<T>) => {
    return <GenericTablePagination {...state} labelDisplayedRows={customLabelDisplayedRows} />;
  };
};
